// extracted by mini-css-extract-plugin
export default {"optionsContainer":"_3XzTc","optionsContainerDesktop":"_2TUOL"};